import * as React from "react";
import { Button } from "@arctheme-components/elements/Button/Button";
import { Paragraph } from "@project-stories/elements/Paragraph/Paragraph";
import { getPaddingButton } from "./TileMethods";
import useColoredTextParser from "@project-stories/../hooks/useColoredTextParser"; // adjust path as needed
import Headings from "@project-stories/elements/Headings/Headings";

const TileContent = ({ data, isMobile }) => {
    const buttonWidth = isMobile ? data.settings.button_width_mobile : data.settings.button_width;
    const paddingContent = getPaddingButton(data);

    // Use the colored text parser hook for the tile title
    const renderFormattedTitle = useColoredTextParser({
        title: data.settings?.title,
        accentTitleParts: data.settings?.accent_title_parts,
        accentColor: data.settings?.accent_color,
        headerStyle: isMobile ? data.settings.title_font_type_mobile : data.settings.title_font_type,
        seoStyle: data.settings?.seo_title_font_type,
        classes: `flex justify-${data.settings.title_alignment_mobile} lg:justify-${data.settings.title_alignment_desktop} text-${data.settings.title_alignment_mobile} lg:text-${data.settings.title_alignment_desktop}`,
        HeadingsComponent: Headings, // fallback to Paragraph below
    });
  
    return (
        <div className={`flex flex-col gap-[${data.settings.content_gap}px]`}>
            {data.settings?.tagline && (
                <Paragraph
                    text={data.settings?.tagline}
                    type={`flex justify-${data.settings.title_alignment_mobile}
                     lg:justify-${data.settings.title_alignment_desktop}
                     ${isMobile ? `b4__regular` : `b3__regular`}`}
                    shouldTruncateText={false}
                />
            )}

            {data.settings?.title && !data.settings?.use_counter && (
                <div className={
                    `flex justify-${data.settings.title_alignment_mobile}
                    lg:justify-${data.settings.title_alignment_desktop}
                    text-${data.settings.title_alignment_mobile}
                    lg:text-${data.settings.title_alignment_desktop}
                    ${isMobile
                        ? data.settings.title_font_type_mobile
                        : data.settings.title_font_type}
                    `}>{renderFormattedTitle()}</div> ||
                <Paragraph
                    text={data.settings?.title}
                    type={
                        `flex justify-${data.settings.title_alignment_mobile}
                        lg:justify-${data.settings.title_alignment_desktop}
                        text-${data.settings.title_alignment_mobile}
                        lg:text-${data.settings.title_alignment_desktop}
                        ${isMobile
                            ? data.settings.title_font_type_mobile
                            : data.settings.title_font_type}
                        `
                    }
                    seo_type={data.settings?.seo_title_font_type}
                    shouldTruncateText={false}
                />
            )}

            {data.settings?.title && data.settings?.use_counter && (
                <>
                    <div
                        x-data={`textcounter({ targetNumber: ${parseFloat(
                            data.settings?.title
                                .replace(/,/g, "")
                                .replace(/<\/?[^>]+(>|$)/g, ""),
                        )}, duration: 5000 })`}
                        x-ref="counterElement"
                    >
                        <p
                            x-text="formattedNumber"
                            className={
                                isMobile
                                    ? data.settings.title_font_type_mobile
                                    : data.settings.title_font_type
                            }
                        ></p>
                    </div>
                </>
            )}

            {data.settings?.content && (
                <Paragraph
                    text={data.settings?.content}
                    type={`
                flex
                justify-${data.settings.text_content_alignment_mobile}
                lg:justify-${data.settings.text_content_alignment_desktop}
                text-${data.settings.text_content_alignment_mobile}
                lg:text-${data.settings.text_content_alignment_desktop}
                ${isMobile ? data.settings.content_font_type_mobile : data.settings.content_font_type} 
                space-y-[${data.settings.content_gap}px]
              `}
                    shouldTruncateText={false}
                />
            )}
            {data.settings.show_button && (
                <div className={`flex
                    justify-${data.settings.button_alignment_mobile}
                    lg:justify-${data.settings.button_alignment_desktop} ${paddingContent}`
                }

                >

                     {data.settings.product ? (
                        <ajax-cart-product-form class="flex w-full space-x-[28px] justify-center h-[42px] items-center bg-white">
                            <form
                                action="/cart/add"
                                id="product_form_id"
                                className="product-form w-full"
                                noValidate
                                data-prodify-product-form
                            >
                                <div className="flex w-full justify-center h5">
                                    <input 
                                        type="hidden" 
                                        name="id" 
                                        value={data.product?.selected_or_first_available_variant?.id || ''} 
                                    />
                                    <button type="submit" className={`${data.settings.button_class} button button-${data.settings?.button_style}`}   style={buttonWidth > 0 ? { width: buttonWidth } : undefined} >
                                        {data.settings.button_text}
                                    </button>
                                </div>
                                <div
                                    data-ajax-cart-errors="form"
                                    className="text-xs text-error-1 mt-2"
                                ></div>
                            </form>
                        </ajax-cart-product-form>
                    ) : (
                        <Button
                            className={`${data.settings.button_class}`}
                            style={data.settings?.button_style}
                            text={true}
                            label={data.settings.button_text}
                            icon={`${data.settings.button_icon}`}
                            link={data.settings.button_url}
                            buttonStyle={buttonWidth > 0 ? { width: buttonWidth } : undefined}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default TileContent;
